import { all, call, put, takeEvery } from "redux-saga/effects";
import { fetchCompanyInformation } from "../../networking/new-space/networking";
import * as types from "../types/new-space";

function* performValidateNewSpace(action) {
  try {
    if (action.details) {
      var response = yield call(fetchCompanyInformation, action.details);
      if (response.error === null && response.payload) {
        yield put({
          type: types.GRANT_VALIDATE_NEW_SPACE,
          data: response.payload,
        });
      } else {
        throw new Error("Error");
      }
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_VALIDATE_NEW_SPACE,
      message: "Kunne ikke validere bedrift.",
    });
  }
}

function* newSpaceSaga() {
  yield all([
    takeEvery(types.REQUEST_VALIDATE_NEW_SPACE, performValidateNewSpace),
  ]);
}

export default newSpaceSaga;
